if (!window.__cartCountdownInit) {
  window.__cartCountdownInit = true;

  const storageKey = 'flowi_cart_countdown_end';
  const defaultDurationMs = 5 * 60 * 1000;
  let tickHandle = null;

  const getDuration = (element) => {
    const duration = Number.parseInt(element?.dataset.duration, 10);
    return Number.isFinite(duration) && duration > 0 ? duration * 1000 : defaultDurationMs;
  };

  const getEndTime = (duration) => {
    const now = Date.now();
    let stored = Number.parseInt(sessionStorage.getItem(storageKey), 10);
    if (!Number.isFinite(stored) || stored <= now || stored - now > duration + 1000) {
      stored = now + duration;
      try {
        sessionStorage.setItem(storageKey, String(stored));
      } catch (error) {}
    }
    return stored;
  };

  const resetEndTime = (duration) => {
    const end = Date.now() + duration;
    try {
      sessionStorage.setItem(storageKey, String(end));
    } catch (error) {}
    return end;
  };

  const formatTime = (milliseconds) => {
    const total = Math.ceil(Math.max(milliseconds, 0) / 1000);
    const minutes = Math.floor(total / 60);
    const seconds = total % 60;
    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  const render = () => {
    const countdowns = document.querySelectorAll('[data-cart-countdown]');
    if (!countdowns.length) {
      if (tickHandle) clearTimeout(tickHandle);
      tickHandle = null;
      return;
    }

    const duration = getDuration(countdowns[0]);
    let end = getEndTime(duration);
    let remaining = end - Date.now();
    if (remaining <= 0) {
      end = resetEndTime(duration);
      remaining = end - Date.now();
    }

    const label = formatTime(remaining);
    countdowns.forEach((countdown) => {
      const time = countdown.querySelector('[data-cart-countdown-time]');
      if (time && time.textContent !== label) time.textContent = label;
    });

    if (tickHandle) clearTimeout(tickHandle);
    let delay = remaining - Math.floor(remaining / 1000) * 1000;
    if (delay <= 0) delay = 1000;
    tickHandle = setTimeout(render, delay + 20);
  };

  const kick = () => {
    if (tickHandle) clearTimeout(tickHandle);
    tickHandle = null;
    render();
  };

  const initialize = () => {
    kick();
    const drawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(kick).observe(drawer, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) kick();
  });
}
